import { render, staticRenderFns } from "./Lgx240444036513529856.vue?vue&type=template&id=2f238918&scoped=true&"
import script from "./Lgx240444036513529856.vue?vue&type=script&lang=js&"
export * from "./Lgx240444036513529856.vue?vue&type=script&lang=js&"
import style0 from "./Lgx240444036513529856.vue?vue&type=style&index=0&id=2f238918&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f238918",
  null
  
)

export default component.exports